import { takeLatest, put, all } from 'redux-saga/effects';
import {
  GET_ORDERS_SUCCESS,
  GET_ORDERS,
  GET_DETAIL,
  GET_DETAIL_SUCCESS,
  SET_LOADING,
  REQUEST_ERROR,
  GET_REFERENCE_DATA,
  GET_REFERENCE_DATA_SUCCESS,
} from '../types/order';

import { requestOrdersApi, requestOrderDetailApi, requestStatusApi } from '../requests/order';

import { onFailRequest } from '../../utils';

/**
 * Get orders with pagination
 * @param {*} payload
 */
function* requestOrders(payload) {
  try {
    const response = yield requestOrdersApi(payload);
    yield put({
      type: GET_ORDERS_SUCCESS,
      data: response,
    });
  } catch (error) {
    yield onFailRequest({
      payload,
      error,
      *onCallback() {
        yield put({ type: REQUEST_ERROR });
      },
    });
  }
}

/**
 * Get reference data
 * @param {*} payload
 */
function* requestReferenceData(payload) {
  try {
    const [orderStatusData] = yield all([requestStatusApi({})]);
    yield put({
      type: GET_REFERENCE_DATA_SUCCESS,
      data: {
        orderStatus: orderStatusData.data,
      },
    });
  } catch (error) {
    yield onFailRequest({
      payload,
      error,
    });
  }
}

/**
 * Get detail data order
 * @param {*} payload
 */
function* requestOrderDetail(payload) {
  try {
    const { params } = payload;
    const { data } = yield requestOrderDetailApi(params);
    yield put({
      type: GET_DETAIL_SUCCESS,
      data,
    });
  } catch (error) {
    yield onFailRequest({
      payload,
      error,
      *onCallback() {
        yield put({ type: SET_LOADING, isLoading: false });
      },
    });
  }
}

export default [
  takeLatest(GET_ORDERS, requestOrders),
  takeLatest(GET_DETAIL, requestOrderDetail),
  takeLatest(GET_REFERENCE_DATA, requestReferenceData),
];
